export default {
  nav: {
    products: "产品与溯源",
    merchant: "商家合作",
    rules: "合规与透明",
    about: "关于肯碗",
    cta: "抢先合作体验",
    menu: "菜单",
  },

  footer: {
    product: "产品",
    about: "关于肯碗",
    coop: "合作",
    merchant: "商家合作",
    ecosystem: "开放生态",
    coopEntry: "合作入口",
    rules: "规则",
    rulesCenter: "规则中心",
    privacy: "隐私政策",
    tagline: "让一笔外卖订单，找到与它对应的过程。",
    notice: "消费者服务开放信息以官方公告为准。",
    operator: "杭州享溯灶智联信息技术服务有限公司",
    address: "地址：浙江省杭州市滨江区西兴街道聚业路7号B幢801室",
    contact: "商务合作：ligang1@kenwan315.com",
    icp: "ICP备案：浙ICP备2026064232号-1",
  },

  leadform: {
    successTitle: "申请已收到",
    successBody:
      "我们将根据您提交的区域、门店情况和合作需求进行初步评估，并通过预留联系方式沟通下一步。",
    backHome: "返回首页",
    sending: "提交中…",
    agree: "提交即表示您同意我们为合作沟通目的处理上述信息，详情请查看",
    privacy: "《隐私政策》",
    end: "。",
    failDefault: "提交失败，请稍后重试",
    netError: "网络异常，请稍后重试",
  },

  home: {
    hero: {
      title1: "真材实料，",
      title2: "更开放的世界。",
      subtitle:
        "肯碗是新一代的餐饮服务平台，建立在可验证的过程之上，让每一餐都更透明、更可信、更公平。",
      explore: "探索肯碗",
      order: "你的订单",
      stepConfirmed: "已确认",
      stepCooking: "制作中",
      stepPacking: "打包中",
      stepDelivering: "配送中",
      traceTitle: "每笔订单都有迹可循",
      traceBody: "从制作到打包，实时看见这一单背后的真实过程。",
      making: "制作中",
      packing: "打包中",
      fromOrder: "从下单到信任",
    },
    value: {
      consumerTitle: "为消费者",
      consumerDesc: "看见餐食是如何被制作与打包的，每一口都更有底气。",
      merchantTitle: "为商家",
      merchantDesc: "让规范经营被看见，以信任赢得更长远的生意。",
      regulatorTitle: "为监管",
      regulatorDesc: "更高效的监督方式，一个更安心的食品安全环境。",
      industryTitle: "为行业",
      industryDesc: "共同构建一个可信、透明的餐饮未来。",
    },
    mission: {
      title1: "让信任",
      title2: "成为一种标准。",
      body: "一个可验证、透明、公平的餐饮生态系统，让每一餐都更健康、更安心。",
      coverage: "订单级溯源覆盖率",
      coverageSub: "支持溯源的订单均可查看",
      coverageValue: "100%",
      retention: "过程影像留存",
      retentionSub: "供对应订单用户回看",
      retentionValue: "15 天",
      storage: "安全数据留存",
      storageSub: "关键记录长期保存",
      storageValue: "3 年",
    },
    insight: {
      eyebrow: "核心认知",
      title1: "不是看一家店，",
      title2: "而是看这一单",
      body: "传统后厨展示通常呈现一家店的整体画面。肯碗更关注一笔具体订单，能否找到与它对应的制作与打包过程。",
      seeStore: "看一家店",
      seeStoreDesc: "查看某个时段的整体后厨画面。",
      seeOrder: "看这一单",
      seeOrderDesc: "从一笔订单出发，找到与其对应的过程记录。",
      note: "肯碗希望建立的，不是更多直播，而是订单与过程之间更清楚的对应关系。",
      overall: "整体画面",
      thisOrder: "这一单",
    },
    product: {
      eyebrow: "产品体验",
      title: "从一笔订单开始",
      body: "订单生成、制作开始、制作完成、打包结束。肯碗围绕同一笔订单组织关键过程信息。",
      stepGen: "订单生成",
      stepGenDesc: "系统形成订单标识。",
      stepStart: "制作开始",
      stepStartDesc: "记录关键操作节点。",
      stepMake: "制作与打包",
      stepMakeDesc: "对应约定操作区域的过程记录。",
      stepView: "本人查看",
      stepViewDesc: "在相应身份和权限范围内访问。",
      makePhase: "制作环节",
      packPhase: "打包环节",
      processRecord: "过程记录",
    },
    tech: {
      eyebrow: "技术支撑",
      title: "技术，让事实更清楚",
      body: "肯碗通过订单、关键时间节点、过程记录与权限控制之间的协同，让一笔外卖订单拥有更清楚的过程信息。",
      note: "公开展示能力原则，不披露底层接口与系统实现细节。",
      core: "订单核心",
      abilityAssoc: "订单与时间关联",
      abilityAssocDesc: "围绕一笔订单记录关键操作节点，使相关过程更容易被找到。",
      abilityIndex: "过程记录索引",
      abilityIndexDesc: "将制作、打包等约定环节的记录与对应订单建立关联。",
      abilityPerm: "权限与操作留痕",
      abilityPermDesc: "根据身份和使用场景控制访问范围，并记录关键操作。",
    },
    coop: {
      eyebrow: "合作",
      title: "从真实场景开始合作",
      body: "肯碗现已开放餐饮商家与机构合作沟通。我们将根据门店条件、使用场景和实际需求，提供相应建议。",
      merchantLabel: "商家合作",
      merchantTitle: "让规范经营被看见",
      merchantDesc: "面向重视透明度、长期经营与品牌信任的餐饮门店及连锁品牌。",
      merchantCta: "申请合作沟通",
      institutionLabel: "机构合作",
      institutionTitle: "让餐饮管理拥有更多过程信息",
      institutionDesc: "面向园区、校园、企业餐饮及相关场景，探索更清楚的过程信息管理方式。",
      institutionCta: "咨询机构方案",
    },
    closing: {
      title1: "让一笔订单，",
      title2: "找到属于它的过程。",
      tagline: "肯一碗，看得见的安心",
      link: "了解产品与溯源",
    },
  },

  about: {
    eyebrow: "关于肯碗",
    title: "让安心有证据",
    intro: "肯碗 KENWAN 是一家以订单级食安溯源为核心能力的网络餐饮服务平台。",
    body: "平台围绕订单关键节点，将制作、打包等过程信息与对应订单建立关联，为消费者、餐饮商家和机构提供更加清楚的过程信息。",
    statCoverage: "订单级溯源覆盖",
    statCoverageSub: "支持溯源的订单均可查看",
    statCoverageValue: "100%",
    statRetention: "过程影像留存",
    statRetentionSub: "供对应订单用户回看",
    statRetentionValue: "15天",
    statStorage: "安全数据留存",
    statStorageSub: "关键记录长期保存",
    statStorageValue: "3年",
    statScenes: "大场景开放合作",
    statScenesSub: "园区 校园 企业 区域",
    statScenesValue: "4",
    missionLabel: "使命",
    mission: "让可核验的过程，成为网络餐饮信任的一部分。",
    visionLabel: "愿景",
    vision: "让「可核验」成为网络餐饮的一项基础能力。",
    valueLabel: "品牌价值观",
    valueTitle: "我们如何做选择",
    valueVerifiable: "可核验",
    valueVerifiableNote: "用事实说话，不夸大。",
    valueTransparent: "透明",
    valueTransparentNote: "在规则范围内，让信息更清楚。",
    valueRestrained: "克制",
    valueRestrainedNote: "不制造恐慌，不夸大承诺。",
    valueFair: "公平",
    valueFairNote: "平衡消费者、商家与机构的利益。",
    valueProfessional: "专业",
    valueProfessionalNote: "以工程与运营能力支撑产品。",
    newsLabel: "前沿观察",
    newsTitle: "关于信任，我们如何思考",
    newsAll: "全部观察",
    newsTag1: "行业观察",
    newsTag2: "公司动态",
    newsTag3: "产品解读",
    newsTag4: "行业科普",
    newsDate1: "2026年9月2日",
    newsDate2: "2026年8月28日",
    newsDate3: "2026年8月19日",
    newsDate4: "2026年8月6日",
    newsTitle1: "从「看直播」到「看这一单」",
    newsTitle2: "肯碗与园区餐饮场景的合作探索",
    newsTitle3: "一张外卖订单，如何找到它背后的过程",
    newsTitle4: "食品安全，为什么需要可核验的证据",
    operatorLabel: "运营主体",
    operator: "杭州享溯灶智联信息技术服务有限公司",
    contactLabel: "联系方式",
    contact: "ligang1@kenwan315.com",
  },

  tech: {
    eyebrow: "产品与溯源",
    title1: "让一笔订单，",
    title2: "找到属于它的过程",
    intro: "肯碗围绕订单、关键时间节点和过程记录建立对应关系，让相关信息能够被组织、查找和核验。",
    schematicLinked: "已关联 4 个节点",
    schematicNote: "围绕一笔订单，将制作、打包等过程记录按时间对齐，形成可核验的过程链路。",
    workLabel: "工作方式",
    workTitle: "一笔订单，四个关键节点",
    node1Title: "订单生成",
    node1Desc: "用户完成下单，系统形成订单标识。",
    node2Title: "制作开始",
    node2Desc: "商家确认开工，记录关键操作节点。",
    node3Title: "制作完成",
    node3Desc: "制作环节结束，记录对应过程。",
    node4Title: "打包结束",
    node4Desc: "打包完成，过程记录与订单建立对应关系。",
    permLabel: "数据与权限",
    permTitle: "信息在正确的范围内被使用",
    permImageLabel: "数据与权限",
    permImageTitle: "信息在正确的范围内被使用",
    principleIdentity: "身份对应",
    principleIdentityDesc: "订单记录与相应用户身份建立访问关系。",
    principleLeast: "最小权限",
    principleLeastDesc: "不同角色只获得完成相应服务所需要的权限。",
    principleAudit: "操作留痕",
    principleAuditDesc: "敏感查看和关键操作形成记录。",
    boundaryLabel: "服务边界",
    boundaryTitle: "技术有边界",
    boundaryBody:
      "肯碗通过过程记录提升信息透明度，但不以视频替代食品检测、专业判断或依法作出的责任认定。",
    boundaryImageLabel: "约定操作区域",
    boundaryImageTitle: "在规则范围内记录",
    boundaryNote:
      "肯碗的过程记录根据门店实际开通方案，覆盖制作、打包等约定操作区域和时间段。食材采购、仓储、配送及非拍摄区域不属于视频记录覆盖范围。相关记录用于提升过程透明度和辅助核验，不构成对食品安全结果的绝对保证。",
    boundaryLink: "查看完整服务规则",
    ctaTitle: "让过程记录，回到真实场景",
    ctaBody:
      "肯碗聚焦订单级食安溯源的产品建设与样板验证，希望与重视长期经营的商家和机构一起，把可核验的过程落实到真实门店。",
    ctaMerchant: "申请门店适配",
    ctaInstitution: "预约技术与方案沟通",
  },

  eco: {
    eyebrow: "开放生态",
    title1: "以开放的方式，",
    title2: "连接更多能力",
    intro: "肯碗围绕机构场景、技术接口、末端配送与产业资源，探索更广泛、更长期的能力协同。",
    instLabel: "机构场景合作",
    instTitle: "让餐饮管理拥有更多过程信息",
    instBody:
      "面向园区、校园、企业餐饮及相关场景，在合法授权和约定范围内，为餐饮管理与问题核验提供辅助信息。",
    instCta: "咨询机构方案",
    instPark: "园区餐饮",
    instCampus: "校园餐饮",
    instCorp: "企业食堂",
    instRegion: "区域餐饮",
    apiLabel: "API 与技术合作",
    apiTitle: "让标准接口被有序开放",
    apiBody:
      "肯碗已将标准化接口纳入平台技术架构，并计划根据产品阶段、安全要求和合作伙伴资质分阶段开放。具体范围和开放时间以双方评估及正式版本为准。",
    apiCopy: "复制",
    apiCopied: "已复制",
    apiButton: "提交技术合作意向",
    apiOrg: "公司或团队名称",
    apiOrgPh: "请输入公司或团队名称",
    apiName: "联系人姓名",
    apiNamePh: "请输入姓名",
    apiEmail: "联系邮箱",
    apiEmailPh: "请输入邮箱",
    apiRegion: "所在城市",
    apiRegionPh: "例如：杭州",
    apiRemark: "合作方向与说明",
    apiRemarkPh: "请简要说明技术方向或合作场景（500字以内）",
    deliveryLabel: "智能末端配送",
    deliveryTitle: "我们正在进行面向未来场景的探索",
    deliveryBody:
      "无人运输车，以及社区、园区、校园及楼宇末端配送机器人，属于肯碗未来战略与合作探索方向，目前不代表相关服务已经正式投入运营。",
    deliveryVehicleEyebrow: "未来方向",
    deliveryVehicle: "无人运输车",
    deliveryRobotEyebrow: "园区 · 校园",
    deliveryRobot: "配送机器人",
    deliveryLobbyEyebrow: "社区 · 楼宇",
    deliveryLobby: "末端配送",
    strategyLabel: "战略投资与产业合作",
    strategyTitle: "与长期伙伴共同成长",
    strategyBody:
      "肯碗面向产业资本，以及具备技术、场景、渠道、供应链或配送资源的长期伙伴开放战略沟通。相关信息不构成公开募集、投资要约或收益承诺。",
    strategyButton: "提交战略合作意向",
    strategyOrg: "机构名称",
    strategyOrgPh: "请输入机构名称",
    strategyName: "联系人姓名",
    strategyNamePh: "请输入姓名",
    strategyDept: "部门或职务",
    strategyDeptPh: "请输入部门或职务",
    strategyEmail: "联系邮箱",
    strategyEmailPh: "请输入邮箱",
    strategyRemark: "合作方向与说明",
    strategyRemarkPh: "请简要说明机构背景或合作方向（500字以内）",
  },

  coop: {
    eyebrow: "合作入口",
    title1: "选择适合你的",
    title2: "合作方向",
    intro:
      "肯碗面向餐饮商家、机构、技术与产业伙伴开放合作沟通。请根据你的身份和合作方向，选择对应的入口。",
    entry1Title: "餐饮商家入驻",
    entry1Desc: "面向重视透明度、长期经营与品牌信任的餐饮门店及连锁品牌。",
    entry1Cta: "提交商家入驻",
    entry2Title: "机构场景合作",
    entry2Desc: "面向园区、校园、企业餐饮及相关场景，探索更清楚的过程信息管理方式。",
    entry2Cta: "咨询机构方案",
    entry3Title: "API 与技术合作",
    entry3Desc: "面向技术与开发伙伴，围绕标准化接口与应用场景开展合作沟通。",
    entry3Cta: "提交技术合作意向",
    entry4Title: "战略投资与产业合作",
    entry4Desc: "面向产业资本及具备技术、场景、渠道、供应链或配送资源的长期伙伴。",
    entry4Cta: "提交战略合作意向",
  },

  merchant: {
    eyebrow: "商家合作",
    title: "让认真经营，有被看见的机会",
    intro:
      "肯碗通过订单级制作与打包过程记录，帮助餐饮商家建立更加透明的经营呈现和更加完整的售后核验信息。",
    applyCta: "申请门店评估",
    fitTitle: "适合哪些商家",
    fit1: "有合法有效经营资质",
    fit2: "后厨操作区域相对清晰",
    fit3: "目前经营外卖存在痛点的",
    fit4: "重视长期口碑",
    fit5: "愿意配合溯源操作与设备维护",
    fit6: "单店、区域连锁或品牌连锁均可沟通",
    planTitle: "根据门店情况选择适配方案",
    planNote: "具体配置、服务范围和费用以门店评估结果及双方正式确认的合作文件为准。",
    plan1Name: "基础溯源方案",
    plan1Fit: "小型单店、快餐、小吃等门店",
    plan1Cover: "以制作区基础记录为主",
    plan1Value: "低门槛建立订单过程记录能力",
    plan2Name: "标准溯源方案",
    plan2Fit: "品牌单店、中型餐饮、饮品、烘焙等门店",
    plan2Cover: "制作与打包关键环节",
    plan2Value: "形成更加完整的订单过程记录",
    plan3Name: "连锁管理方案",
    plan3Fit: "多门店品牌、区域连锁、餐饮企业",
    plan3Cover: "多点位与多门店统一管理",
    plan3Value: "统一查看门店运营、设备与溯源情况",
    fitLabel: "适合",
    coverLabel: "覆盖",
    valueLabel: "价值",
    planCta: "获取适配方案",
    stepTitle: "合作流程",
    step1Title: "提交意向",
    step1Desc: "填写门店、区域和联系人信息。",
    step2Title: "门店适配评估",
    step2Desc: "确认门店面积、操作区域、网络及点位需求。",
    step3Title: "确认方案",
    step3Desc: "明确硬件配置、服务范围、费用和双方权责。",
    step4Title: "安装联调",
    step4Desc: "完成设备安装、系统接入和功能测试。",
    step5Title: "培训上线",
    step5Desc: "完成门店操作培训，通过验收后正式开启服务。",
    applyTitle: "提交入驻申请",
    applyBody: "留下基础信息，专属顾问将与你联系，为你定制接入方案。",
    applyButton: "提交入驻申请",
    fName: "联系人姓名",
    fNamePh: "请输入姓名",
    fPhone: "联系电话",
    fPhonePh: "请输入手机号",
    fRegion: "所在城市",
    fRegionPh: "例如：杭州滨江",
    fStore: "门店或品牌名称",
    fStorePh: "请输入门店名称",
    fCount: "门店数量",
    fCountPh: "例如：3家",
    fCategory: "主营品类",
    fCategoryPh: "例如：快餐/饮品",
    fRemark: "补充说明",
    fRemarkPh: "如需说明门店情况或合作需求，可在此补充（500字以内）",
  },

  institution: {
    eyebrow: "机构合作",
    title1: "为餐饮管理提供",
    title2: "更多过程信息",
    intro:
      "肯碗围绕订单、商户、设备和溯源记录，提供数字化辅助能力，可根据园区、校园及企业餐饮场景进行方案沟通。",
    abilityLabel: "能力模块",
    abilityTitle: "一套面向管理侧的数字化工具",
    ability1Title: "商户概览",
    ability1Desc: "查看项目范围内接入主体、设备状态及溯源覆盖情况。",
    ability2Title: "异常发现",
    ability2Desc: "对设备离线、记录缺失和操作异常进行提示。",
    ability3Title: "投诉协同",
    ability3Desc: "在合法权限范围内协助查找相关订单和过程材料。",
    ability4Title: "数据汇总",
    ability4Desc: "按项目范围形成门店、订单和溯源运行情况统计。",
    scenarioLabel: "适用场景",
    scenarioTitle: "覆盖多种餐饮管理场景",
    scenario1Title: "园区餐饮",
    scenario1Desc: "园区餐饮集中溯源与异常筛查",
    scenario2Title: "校园餐饮",
    scenario2Desc: "学校食堂过程信息与家校沟通",
    scenario3Title: "企业食堂",
    scenario3Desc: "企业员工餐饮过程信息支持",
    scenario4Title: "区域餐饮",
    scenario4Desc: "区域网络餐饮数字化辅助管理",
    applyTitle: "咨询机构方案",
    applyBody: "留下对接信息，我们将安排方案团队与您沟通实际场景和合作需求。",
    applyButton: "咨询机构方案",
    fOrg: "单位名称",
    fOrgPh: "请输入单位名称",
    fName: "联系人姓名",
    fNamePh: "请输入姓名",
    fDept: "部门或职务",
    fDeptPh: "请输入部门或职务",
    fRegion: "所在区域",
    fRegionPh: "例如：杭州滨江",
    fScene: "关注场景",
    fScenePh: "例如：校园/园区/企业餐饮",
    fPhone: "联系电话",
    fPhonePh: "请输入手机号",
    fRemark: "补充说明",
    fRemarkPh: "如需说明具体场景或需求，可在此补充（500字以内）",
  },

  rules: {
    eyebrow: "规则中心",
    title: "规则与权益",
    intro: "肯碗平台的服务规则与用户权益说明。尚未正式生效的文件，将在正式服务开放后发布。",
    statusView: "可查看",
    statusPending: "正式服务开放后生效",
    rule1: "用户服务协议",
    rule2: "隐私政策",
    rule3: "敏感个人信息处理说明",
    rule4: "向第三方提供个人信息说明",
    rule5: "食安溯源服务规则",
    rule6: "平台商户管理规范",
    rule7: "规则与公告",
    viewFull: "查看全文",
    pending: "待发布",
  },

  privacy: {
    eyebrow: "隐私政策",
    title: "隐私政策",
    draft: "（草案，正式服务开放后生效）",
    s1Title: "一、信息采集",
    s1Body:
      "肯碗坚持最小化采集原则，仅收集与提供食安溯源服务直接相关的必要信息，包括商家经营信息、订单关联信息及为完成溯源所必需的记录数据。",
    s2Title: "二、信息使用",
    s2Body:
      "我们仅在向您提供服务、保障食安溯源可核验性及履行法定义务所必需的范围内使用相关信息，不用于与服务无关的用途。",
    s3Title: "三、信息保护",
    s3Body: "平台对信息实施分级权限管理，采用加密传输与访问控制等技术手段，防止信息被未经授权的访问、使用或泄露。",
    s4Title: "四、您的权利",
    s4Body: "您有权依法查阅、更正、删除您的个人信息，并可通过下方联系方式向我们提出相关请求。",
    s5Title: "五、联系我们",
    s5Body: "如对本政策有任何疑问，可通过页脚所示联系方式与我们联系。",
  },

  terms: {
    eyebrow: "用户服务协议",
    title: "用户服务协议",
    draft: "（草案，正式服务开放后生效）",
    s1Title: "一、服务说明",
    s1Body:
      "肯碗向商家、消费者及合作机构提供制作与打包等约定环节的订单级溯源服务，包括订单对应的过程记录、核验及相关数据服务。",
    s2Title: "二、用户义务",
    s2Body: "用户应保证所提交信息的真实、准确，并对自身操作的真实性负责，不得利用服务从事任何违法违规活动。",
    s3Title: "三、数据与留痕",
    s3Body: "平台按订单归档留存必要记录，具体保存期限与处理方式以相关规则为准。",
    s4Title: "四、免责声明",
    s4Body: "因不可抗力或非平台原因导致的服务中断或数据延迟，平台不承担相应责任，但将尽合理努力及时恢复服务。",
    s5Title: "五、条款变更",
    s5Body: "平台有权根据业务发展调整本条款，更新后的条款将在本页公示，继续使用服务即视为接受变更。",
  },
};